import { render, staticRenderFns } from "./quicklist.vue?vue&type=template&id=94dbbf2e"
import script from "./quicklist.vue?vue&type=script&lang=js"
export * from "./quicklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports